module.exports = __webpack_public_path__ + "static/media/menu_offer_gradline.b8ae6137.svg";